import { render, staticRenderFns } from "./DashboardSummary.vue?vue&type=template&id=be61a122&"
import script from "./DashboardSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports